// Home page's uniform video grid — unrelated to the /gallery page's live
// album data below.
export const GALLERY_VIDEOS = [
  {
    id: 'gal1',
    tag: 'SATSANG',
    title: 'VEDIC WISDOM: UNDERSTANDING PLANETARY POINTS',
    image: 'https://picsum.photos/seed/gal1/800/600',
    embed: 'https://www.youtube.com/embed/VIDEO_ID_1?autoplay=1',
  },
  {
    id: 'gal2',
    tag: 'ACADEMY',
    title: 'THE SCIENCE OF YANTRAS AND COSMIC ENERGY',
    image: 'https://picsum.photos/seed/gal2/800/600',
    embed: 'https://www.youtube.com/embed/VIDEO_ID_2?autoplay=1',
  },
  {
    id: 'gal3',
    tag: 'RITUALS',
    title: 'SACRED RITUALS FOR ENVIRONMENTAL STABILITY',
    image: 'https://picsum.photos/seed/gal3/800/600',
    embed: 'https://www.youtube.com/embed/VIDEO_ID_3?autoplay=1',
  },
]

function unwrap(res) {
  if (res && typeof res === 'object' && 'data' in res && res.data !== undefined) return res.data
  return res
}

function toEmbeddableVideo(raw) {
  if (!raw) return null
  if (/youtube\.com|youtu\.be/.test(raw)) {
    if (raw.includes('/embed/')) return { kind: 'embed', src: raw }
    const watchMatch = raw.match(/[?&]v=([^&]+)/)
    if (watchMatch) return { kind: 'embed', src: `https://www.youtube.com/embed/${watchMatch[1]}?autoplay=1` }
    const shortMatch = raw.match(/youtu\.be\/([^?]+)/)
    if (shortMatch) return { kind: 'embed', src: `https://www.youtube.com/embed/${shortMatch[1]}?autoplay=1` }
    return { kind: 'embed', src: raw }
  }
  // Direct file (mp4 etc.) — played with a native <video> tag instead of an iframe.
  return { kind: 'file', src: raw }
}

function urlOf(entry) {
  if (typeof entry === 'string') return entry
  return entry?.url ?? entry?.video_url ?? entry?.image_url ?? entry?.path ?? null
}

/**
 * A /gallery record is an ALBUM (verified against the live response): a
 * cover image plus a bundle of `images` and (per `total_videos`) `videos`.
 * There's no per-photo title/tag — captions live at the album level.
 */
export function normalizeGalleryAlbum(raw) {
  if (!raw) return null

  const images = Array.isArray(raw.images) ? raw.images.map(urlOf).filter(Boolean) : []
  const videos = Array.isArray(raw.videos) ? raw.videos.map(urlOf).filter(Boolean) : []

  const media = [
    ...videos.map((src) => ({ type: 'video', ...toEmbeddableVideo(src) })),
    ...images.map((src) => ({ type: 'image', src })),
  ]

  return {
    id: raw.id,
    title: raw.title ?? raw.name ?? 'Untitled',
    description: raw.description ?? raw.caption ?? null,
    coverImage: raw.cover_image ?? raw.thumbnail ?? images[0] ?? null,
    media,
    totalImages: raw.total_images ?? images.length,
    totalVideos: raw.total_videos ?? videos.length,
    totalMedia: raw.total_media ?? media.length,
    createdAt: raw.created_at ?? null,
  }
}

/** Tolerates the live `{ success, message, data: [...], meta: {...} }`
 * envelope, a nested Laravel paginator, or a bare array. */
export function unwrapGalleryList(res) {
  if (res && typeof res === 'object' && Array.isArray(res.data) && res.meta && typeof res.meta === 'object') {
    const m = res.meta
    return {
      items: res.data.map(normalizeGalleryAlbum),
      currentPage: m.current_page ?? 1,
      lastPage: m.last_page ?? 1,
      total: m.total ?? res.data.length,
    }
  }
  const d = unwrap(res)
  if (Array.isArray(d)) {
    return { items: d.map(normalizeGalleryAlbum), currentPage: 1, lastPage: 1, total: d.length }
  }
  if (d && Array.isArray(d.data)) {
    return {
      items: d.data.map(normalizeGalleryAlbum),
      currentPage: d.current_page ?? 1,
      lastPage: d.last_page ?? 1,
      total: d.total ?? d.data.length,
    }
  }
  return { items: [], currentPage: 1, lastPage: 1, total: 0 }
}

export function unwrapGalleryItem(res) {
  return normalizeGalleryAlbum(unwrap(res))
}
